// extracted by mini-css-extract-plugin
module.exports = {"color":"ConnectEvmWallet_color__s7YsL","buttonOutline":"ConnectEvmWallet_buttonOutline__6bg0o"};